class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Delegation survives Shopify section replacement. No dependency or polling.
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.ergosia-one-cross-sell--drawer .ergosia-one-cross-sell__form');
  if (!form) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  form.dataset.pending = 'true';
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[role="alert"]');
  button.disabled = true; button.textContent = 'Ajout en cours…';
  if (error) error.hidden = true;
  let added = false;
  try {
    const body = new FormData(form);
    body.delete('return_to');
    body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    body.set('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Cet article ne peut pas être ajouté pour le moment.');
    added = true;
    const sections = drawer.getSectionsToRender().map(section => section.id);
    if (!result.sections || sections.some(id => !result.sections[id])) {
      const url = new URL(window.location.href);url.searchParams.set('sections', sections.join(','));
      const refresh = await fetch(url);if (!refresh.ok) throw new Error('Affichage du panier indisponible.');
      result.sections = await refresh.json();
    }
    drawer.renderContents(result);
    const inner = drawer.querySelector('.drawer__inner');
    const notice = document.createElement('p');
    notice.className = 'ergosia-cart-added';notice.setAttribute('role','status');
    notice.textContent = '✓ Article ajouté — votre total est mis à jour.';
    inner.querySelector('.drawer__header').after(notice);
    drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
    setTimeout(() => { const close = drawer.querySelector('.drawer__close'); if (close) close.focus(); }, 50);
  } catch (err) {
    if (error) {error.textContent = added ? 'Article ajouté. Actualisez le panier pour voir son nouveau total ; ne l’ajoutez pas une seconde fois.' : (err.message || 'Vérifiez votre panier avant de réessayer.');error.hidden = false;}
    button.textContent = added ? 'Article ajouté' : 'Vérifier puis réessayer';
    // A network error can be an uncertain write: never automatically retry.
  } finally {
    if (!added) {button.disabled = false;form.dataset.pending = 'false';}
  }
});
